<script>
import navbarFilter from './navbar-filter.vue'
import navbarMenu from './navbar-menu.vue'

export default {
    components: {navbarFilter, navbarMenu},
    props: {
        favMode: {type: Boolean, default: false},
        locations: {type: Array, required: true},
        languages: {type: Array, required: true},
        streams: {type: Array, required: true},
        talkTypes: {type: Array, required: true},
        filter: {type: Object, required: true},
        menuItems: {type: Array, required: true}, /*
            * sample menu item:
            * {
            *   label: 'Foobar'
            *   items: [
            *      {
            *       label: 'Foo',
            *       fn: foobarAction
            *      },
            *   ]
            * }
            */
        toolButtons: {type: Array, required: true}, /*
            * sample button:
            *      {
            *       label: 'Favoriten'
            *       icon: 'fas fa-bookmark',
            *       fn: foobarAction
            *      },
            */
    },
    data() {
        return {
            search: this.filter.search,
            searchActive: !!this.filter.search,
            togglerCollapsed: true,
            tButtons: [...this.toolButtons],
        }
    },
    created() {
        if (this.favMode)
            this.tButtons.splice(1, 1)  // remove favorites button, keep history
    },
    methods: {
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        },
        activateSearch() {
            this.searchActive = true
            this.$nextTick(() => this.$refs.searchInput.focus())
        },
        deactivateSearch() {
            this.searchActive = false
            this.search = ''
            this.$emit('delete-search')
        },
    },
}
</script>

<template>
<nav class="c-talk-navbar navbar navbar-expand-lg justify-content-between bg-light px-3">

  <button class="navbar-toggler p-1 btn navbar-btn btn-sm mb-1 border-0 bg-transparent" type="button" @click.prevent="togglerCollapsed=!togglerCollapsed">
    <i class="fas fa-bars"></i>
  </button>

  <template v-if="!searchActive">
    <button v-for="(btn, index) in tButtons" :key="index" class="btn btn-sm navbar-btn me-1 mb-1 c-tool-btn"
        @click.prevent="btn.fn">
        <i :class="btn.icon"></i>
        <span v-if="btn.label" class="c-tool-btn-label">{{ btn.label }}</span>
    </button>
  </template>

  <div v-if="!searchActive" class="navbar-collapse" :class="{collapse: togglerCollapsed}" id="navbarNavDropdown">
    <ul class="navbar-nav gap-1">
        <navbar-filter v-if="locations.length"
         label="Bühne" :filterValues="locations" :activeFilterValues="filter.location"
         @toggle-filter="$emit('toggle-location', $event)" />

        <navbar-filter v-if="streams.length"
         label="Topic" :filterValues="streams" :activeFilterValues="filter.streams"
         @toggle-filter="$emit('toggle-stream', $event)" />

        <navbar-filter v-if="languages.length"
         label="Sprache" :filterValues="languages" :activeFilterValues="filter.language"
         @toggle-filter="$emit('toggle-language', $event)" />

        <navbar-filter v-if="talkTypes.length"
         label="Format" :filterValues="talkTypes" :activeFilterValues="filter.talk_type"
         @toggle-filter="$emit('toggle-talk-type', $event)" />

        <navbar-menu v-for="(menu, index) in menuItems" :key="index" :label="menu.label" :items="menu.items" />
    </ul>
  </div>

  <div class="c-search-wrap" :class="{'c-search-wrap--active': searchActive}">
    <form class="ms-auto form-inline" @submit.prevent="$emit('search', search)">
      <div class="d-flex flex-nowrap align-items-center gap-1">
        <input v-if="searchActive" ref="searchInput"
               class="c-search-input form-control input-sm" type="search" placeholder="Suche"
               v-model="search"
               @input="onSearchInput()"
               @keyup.enter="$emit('search', search)">
        <button v-if="searchActive" type="button" class="btn btn-sm " @click.prevent="$emit('search', search)">
          <span class="fa fa-search"></span>
        </button>
        <button v-if="searchActive" type="button" class="btn btn-sm " @click.prevent="deactivateSearch">
          <span class="fa fa-times"></span>
        </button>
        <button v-if="!searchActive" type="button" class="btn btn-sm  mb-1" @click.prevent="activateSearch">
          <span class="fa fa-search"></span>
        </button>
      </div>
    </form>
  </div>

</nav>
</template>

<style scoped>
.c-tool-btn {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.2;
}
.c-tool-btn-label {
    font-size: 0.65rem;
    margin-top: 2px;
}

.c-search-input {
    font-size: 1rem;
    padding: 0.2rem 0.4rem;
    width: 100%;
}

.c-search-wrap {
    flex-shrink: 0;
}

.c-search-wrap--active {
    flex-grow: 1;
}
</style>
